import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'loader-bloqueante',
  templateUrl: './loader-bloqueante.component.html',
  styleUrls: ['./loader-bloqueante.component.scss'],
})
export class LoaderBloqueanteComponent implements OnInit {
  @Input() mensaje:string ="Aguarde..."
  @Input() bajada: string = ""
  @Input() bloquear: boolean = false
  constructor() { }

  ngOnInit() {}

  ngAfterViewInit(){
    this.calcMarging();
  }

  calcMarging(){
    let me = document.getElementsByClassName("i-loader-box");
    for (let index = 0; index < me.length; index++) {
      const el:any = me[index];
      let p = el.parentElement
      if(el && p){
        let h = p.clientHeight;
        el.style.marginTop = "min(30vh,"+ (h/2) +"px - 20px )"
      }
    }
  }
}

